export default function Header() {
  return (
    <div className="absolute z-50 left-0 top-0 py-[10.5px] px-[24px] lg:px-[48px] lg:py-[12px]">
      <div className="select-none">
        <img src="/cr7-logo.svg" alt="bg" className="size-10 lg:size-[54px]" />
      </div>
    </div>
  );
}
